import React, { type FC } from "react";
import { SessionGate } from "@app/bootstrap/SessionGate";
import { useAuthStore } from "@app/store/useAuthStore";
import { MobileAppShell } from "../shell/mobile-app-shell";

/**
 * Корневой layout: для авторизованного пользователя блокирует shell до bootstrap,
 * как RootLayout в NBP — login даёт только token, user/labouring грузит SessionGate.
 */
export const RootLayout: FC = () => {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

    if (isAuthenticated) {
        return (
            <SessionGate>
                <MobileAppShell />
            </SessionGate>
        );
    }

    return <MobileAppShell />;
};
